import axios from "axios";
import store from "store2";

export async function apiGet(url) {
  const token = store.session.get("token");

  let response;
  if (token) {
    response = await axios.get(`${process.env.REACT_APP_API_URL}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    response = await axios.get(`${process.env.REACT_APP_API_URL}${url}`);
  }

  return response;
}

export async function apiPost(url, params = {}) {
  const token = store.session.get("token");

  let response;
  if (token) {
    const config = {
      headers: { Authorization: `Bearer ${store.session.get("token")}` },
    };

    response = await axios.post(
      `${process.env.REACT_APP_API_URL}${url}`,
      params,
      config
    );
  } else {
    response = await axios.post(
      `${process.env.REACT_APP_API_URL}${url}`,
      params
    );
  }

  return response;
}

export async function apiPut(url, params = {}) {
  const config = {
    headers: { Authorization: `Bearer ${store.session.get("token")}` },
  };

  const response = await axios.put(
    `${process.env.REACT_APP_API_URL}${url}`,
    params,
    config
  );

  return response;
}

export async function apiDelete(url, params = {}) {
  const token = store.session.get("token");

  let response;
  if (token) {
    const config = {
      headers: { Authorization: `Bearer ${store.session.get("token")}` },
    };

    response = await axios.delete(
      `${process.env.REACT_APP_API_URL}${url}`,
      config,
      params
    );
  } else {
    response = await axios.delete(
      `${process.env.REACT_APP_API_URL}${url}`,
      params
    );
  }

  return response;
}
